const baseURL = process.env.VUE_APP_API_BASE || '/api'

export default {
  baseURL
}
